import { useEffect, useState, useRef } from 'react';
function useIntersectionObserver(threshold = 0) {
    const [isIntersecting, setIsIntersecting] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                setIsIntersecting(entry.isIntersecting);
            });
        }, {
            threshold,
        });
        if (ref.current) {
            observer.observe(ref.current);
        }
        // Cleanup the observer when component unmounts
        return () => {
            observer.disconnect();
        };
    }, [threshold]);
    return { ref, isIntersecting };
}
export default useIntersectionObserver;
